<template>
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="false"></Topo>
    <Migalha label="Histórico de Solicitações"></Migalha>    
    <v-data-table :headers="headers" :items="fornecedoresCadastrados" class="tableLista"
    :hide-actions="$verificaPerfilCadastrador() ? true : false"
    :pagination.sync="pagination">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center" nowrap>
          <v-tooltip top v-if="situacoesEditaveis.includes(props.item.situacaoSolicitacao)">
            <v-btn slot="activator" icon @click="editItem(props.item)">
              <v-icon color="primary">edit</v-icon>
            </v-btn>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top v-if="situacoesCancelaveis.includes(props.item.situacaoSolicitacao)">
            <v-btn slot="activator" icon @click="cancelarItem((props.item))">
              <v-icon color="error">block</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
        </td>
        <td>{{ props.item.numCgcFornecedor | formatCpfCnpj }}</td>
        <td class="text-xs-left" nowrap>{{ props.item.nomFornecedor }}</td>
        <td class="text-xs-left" nowrap>{{ props.item.endEmail }}</td>
        <td class="text-xs-left" nowrap>{{ props.item.numTelefone }}</td>
        <td class="text-xs-left" nowrap>{{ props.item.dataSolicitacao | formatDate }}</td>
        <td class="text-xs-left" nowrap>
          {{
          enums.situacaoSolicitacao.find(x=>x.valor==props.item.situacaoSolicitacao)["descricao"]
          }}
        </td>
      </template>
    </v-data-table>
     <br><br><br>
    <v-flex class="legenda" >
      <v-layout fill-height>
        <v-icon color="primary">edit</v-icon>
        <span class="pt-1">Alterar</span>
        <v-icon color="error">block</v-icon>
        <span class="pt-1">Cancelar</span>
      </v-layout>
    </v-flex>
    <v-dialog v-model="dialog" persistent max-width="520px" light>
      <v-card>
        <v-card-title class="headline">Cadastrar Fornecedor</v-card-title>
        <v-card-text>
          <v-form v-model="valid" lazy-validation ref="formCadastro" v-if="dialog">
            <v-layout row wrap class="radiosLogin">
              <v-flex xs12 sm5>
                <v-radio-group v-model="model.flagEstrangeiro" class="mb-0" @change="changeFlagEstrangeiro">
                  <v-radio label="Brasileiro" value="0"></v-radio>
                  <v-radio label="Estrangeiro" value="1"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 sm7>
                <v-radio-group v-model="model.tipFornecedor" class="mb-0" :readonly="readonlyTipFornecedor">
                  <v-radio :label="$t('label.pessoaJurica')" value="J"></v-radio>
                  <v-radio :label="$t('label.pessoaFisica')" value="F"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  v-if="model.flagEstrangeiro == 0 && model.tipFornecedor =='J'"
                  key="num_CgcFornecedorCommMaskPJ"
                  v-model="model.numCgcFornecedor"
                  :label="$t('label.cnpj') +' *'"
                  v-mask="maskCnpj"
                  :rules="validacao.cnpj"
                  validate-on-blur
                  required
                ></v-text-field>
                <v-text-field
                  v-if="model.flagEstrangeiro == 0 && model.tipFornecedor =='F'"
                  key="num_CgcFornecedorCommMaskPF"
                  v-model="model.numCgcFornecedor"
                  :label="$t('label.cpf')+' *' "
                  v-mask="maskCpf"
                  :rules="validacao.cpf"
                  required
                  validate-on-blur
                ></v-text-field>
                <v-text-field
                  v-if="model.flagEstrangeiro == 1"
                  key="num_CgcFornecedorSemMask"
                  v-model="model.numCgcFornecedor"
                  :label="$t('label.codCredorFiplan')+' *'"
                  :rules="validacao.codigoCredor"
                  validate-on-blur
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  v-model="model.nomFornecedor"
                  :label="(model.tipFornecedor =='J') ? $t('label.razaoSocial')+' *' : $t('label.nome')+' *' "
                  :rules="validacao.campoObrigatorio"
                  required
                  validate-on-blur
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-spacer></v-spacer>

            <v-layout row p-b-15 p-t-10>
              <v-flex sm6>
                <v-btn large color="success" @click="cancelar()">Cancelar</v-btn>
              </v-flex>

              <v-flex sm6>
                <v-btn large color="info" @click="cadastrar()">Cadastrar</v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import util from "../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import Migalha from "../../components/migalha";
import Topo from "../../components/Topo";
import cadastradorService from "../../services/cadastradorService";
import dominioService from "../../services/dominioService";
import fornecedorService from "../../services/fornecedorService";

export default {
  name: "cadastrador",
  mixins: [util],
  components: { /*Componentes utilizados*/
    Migalha,
    Topo
  },
  created() /*Metodo de start do componente*/{
    if (!this.$verificaPerfilCadastrador()) {
      this.$toasted.error(this.$t("messages.validacao.usuarioSemPermissao"));
      this.$router.push("loginrestrito");
    } else {
      this.carregarTabelaCadastrados();
    }
  },
  data() {//Declaracao de variaveis
    return {
      headers: [ /*Cabeçalho da data-table*/],
      fornecedoresCadastrados: [],
      dialog: false,
      model: {
        isBrasileiro: true,
        isEstrangeiro: false,
        tipFornecedor: "J",
        flagEstrangeiro: "0",
        flagSociedadeAnonima: "0",
      },
      valid: true,
      enums: {},
      situacoesCancelaveis: [0,1], // 0 - Iniciado pelo Cadastrador, 1 - Pendente de Envio
      situacoesEditaveis: [0,1],
      readonlyTipFornecedor: false,
      pagination: {            
        rowsPerPage: this.$verificaPerfilCadastrador() ? 10 : 5
      }
    };
  },
  methods: {//Declaracao de todos os metodos
    openCadastrarFornecedor() {
      this.dialog = true;
    },
    cancelar() {
      this.model = {
        isBrasileiro: true,
        isEstrangeiro: false,
        tipFornecedor: "J",
        flagEstrangeiro: "0",
        flagSociedadeAnonima: "0",
      };
      this.valid = true;

      this.dialog = false;
    },

    editItem(item) {
      this.$router.push({
        path: `/arearestrita/cadastrador/cadastrar-solicitacao/${item.idFornecSolicitacao}`
      });
    },

    cadastrar() {
      if (this.$refs.formCadastro.validate()) {
        this.model.numCgcFornecedor = this.model.numCgcFornecedor.replace(
          /[^A-Z0-9]/gi,
          ""
        );
        cadastradorService.cadastroinicial(this.model).then(response => { /*resposta do servico*/

          this.$router.push("/arearestrita/cadastrador/cadastrar-solicitacao/"+ response.data.idFornecSolicitacao);

        });
      }
    },

    carregarTabelaCadastrados() {
      this.headers = [
        { text: "Ações", value: "", width: 10, sortable: false, class: "text-xs-center"},
        { text: "CPF/CNPJ", value: "numCgcFornecedor", width: 100, sortable: false, },
        { text: "Fornecedor", value: "Fornecedor", width: 400, sortable: false, },
        { text: "E-Mail", value: "endEmail", width: 100, sortable: false,  },
        { text: "Telefone", value: "numTelefone", width: 100, sortable: false,  },
        { text: "Data Solicitação", value: "dataSolicitacao", width: 100, sortable: false,  },
        { text: "Situação da Solicitação", value: "situacaoSolicitacao", width: 100, sortable: false,  }
      ];
      dominioService.geEnums().then(responseEnums => {
        cadastradorService.getFornecedoresCadastrados().then(response => { /*resposta do servico*/
          this.fornecedoresCadastrados = response.data; /*dados de retorno*/

        // #145473-Se o perfil for Cadastrador todos os itens serao exibidos na tela
        if(this.$verificaPerfilCadastrador()){
          this.pagination.rowsPerPage = this.fornecedoresCadastrados.length;
        }

          this.enums = responseEnums.data;
          let arrayEnum = this.enums.situacaoSolicitacao;

        arrayEnum.forEach(function (item){

          if (item.chave == 'Aceitar'){
              item.descricao = "Aguardando Análise";
          }else if(item.chave == 'Rejeitar'){
                item.descricao = "Indeferida";}  
        });

        });
      });
    },

    consultarFornecedor() {
      //consultar fornecedor
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      this.$router.push("/arearestrita/habilitador/consulta-cadastro");
      this.$removePreload(); /*Ocultar o PreLoad*/
    },

    cancelarItem(item) {
      //cancelar solicitacao escolhida
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      fornecedorService
        .fornecedorCancelarSolicitacao(item.idFornecSolicitacao)
        .then(response => { /*resposta do servico*/
          if (response.data == true) {
            this.carregarTabelaCadastrados();
            this.$removePreload(); /*Ocultar o PreLoad*/
            this.$toasted.success("Cancelado com sucesso.");
          }
        });
    },

    changeFlagEstrangeiro(event){
      if(event === "1"){
        this.readonlyTipFornecedor = true;
        this.model.tipFornecedor = 'J';
      }else{
        this.readonlyTipFornecedor = false;
      }
    }
  }
};
</script>

<style>
.tableLista .v-table {
  width: auto !important;
  max-width: none !important;
}

.legenda{
  margin-top: -50px;
}

.legenda .v-icon{
  padding-left: 15px;
  padding-right: 5px;
}
</style>